import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'puderbach',
} as IModuleProps;
